export const transform = (item) => {
  return {
    appId: item.id,
    appName: item.customTitle ? item.customTitle : item.title,
    appUrl: item.linkUrl,
    category: item.category,
    description: item.description,
    cardImage: item.thumbnailUrl,
    cardImageMobile: item.thumbnailUrlMobile,
    isFavorite: item.isFavorite,
    favoritedAt: item.favoritedAt,
    isNewApp: item.isNewApp,
  }
}

export const transformMany = (items) => {
  return items.map((item) => transform(item))
}
